'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { Link, Locale, useLocation } from '@custom/schema';
import { Menu, MenuButton, MenuItem, MenuItems, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import clsx from 'clsx';
import React, { Fragment } from 'react';
import { useTranslations } from '../../utils/translations';
function getLanguageName(locale) {
    var formattedLocale = formatLocalePath(locale);
    var languageNames = new Intl.DisplayNames([
        formattedLocale
    ], {
        type: 'language'
    });
    return languageNames.of(formattedLocale);
}
/**
 * Format locale containing the country code,
 * so it's ISO 639-1 compliant in the path.
 * This is needed as GraphQL enums are not supporting dashes (-).
 *
 * @param locale
 */ function formatLocalePath(locale) {
    return locale.replace('_', '-');
}
export function LanguageSwitcher() {
    var _Object_entries_find;
    var translations = useTranslations();
    var _useLocation = _sliced_to_array(useLocation(), 1), location = _useLocation[0];
    var currentLocale = (_Object_entries_find = Object.entries(translations).find(function(param) {
        var _param = _sliced_to_array(param, 2), path = _param[1];
        return path === location.pathname;
    })) === null || _Object_entries_find === void 0 ? void 0 : _Object_entries_find[0];
    var isMultiLingual = Object.keys(translations).length > 1;
    return /*#__PURE__*/ React.createElement("div", {
        className: "relative inline-block text-left"
    }, /*#__PURE__*/ React.createElement(Menu, {
        as: "div",
        className: "relative inline-block text-left"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(React.Fragment, {
        key: currentLocale
    }, /*#__PURE__*/ React.createElement(MenuButton, {
        className: clsx('inline-flex w-full justify-center rounded-md bg-white text-sm font-medium', {
            'hover:text-blue-600': isMultiLingual,
            'cursor-not-allowed opacity-70': !isMultiLingual
        }),
        disabled: !isMultiLingual
    }, getLanguageName(currentLocale !== null && currentLocale !== void 0 ? currentLocale : 'en'), /*#__PURE__*/ React.createElement(ChevronDownIcon, {
        className: "ml-1 size-5",
        "aria-hidden": "true"
    })))), /*#__PURE__*/ React.createElement(Transition, {
        as: Fragment,
        enter: "transition ease-out duration-200",
        enterFrom: "opacity-0 translate-y-1",
        enterTo: "opacity-100 translate-y-0",
        leave: "transition ease-in duration-150",
        leaveFrom: "opacity-100 translate-y-0",
        leaveTo: "opacity-0 translate-y-1"
    }, /*#__PURE__*/ React.createElement(MenuItems, {
        className: "absolute right-0 z-50 mt-3 w-48 origin-top-right rounded bg-white shadow-md ring-1 ring-gray-100"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "py-1"
    }, Object.values(Locale).map(function(locale) {
        return /*#__PURE__*/ React.createElement(React.Fragment, {
            key: locale
        }, translations[locale] && location.pathname !== translations[locale] ? /*#__PURE__*/ React.createElement(MenuItem, null, function(param) {
            var focus = param.focus;
            return translations[locale] ? /*#__PURE__*/ React.createElement(Link, {
                href: translations[locale],
                className: clsx(focus ? 'text-blue-600' : 'text-gray-500', 'block px-4 py-2 text-sm')
            }, getLanguageName(locale)) : /*#__PURE__*/ React.createElement("span", {
                className: clsx(focus ? 'bg-gray-100 text-gray-900' : 'text-gray-500', 'block px-3.5 py-2 text-sm opacity-70')
            }, getLanguageName(locale));
        }) : null);
    }))))));
}
